<section id="content" class="content">
  <div class="content__boxed w-100 min-vh-100 d-flex flex-column align-items-center justify-content-center">
    @if (showError) {
      <div class="content__wrap">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="alert alert-danger" role="alert">
              <h1 class="h3">
                <i class="fa-solid fa-circle-x"></i>
                {{'LOGIN_ERROR' | translation}}
              </h1>
            </div>
            <div class="text-center">
              <p>{{ errormsg }}</p>
            </div>
            <div class="d-grid">
              <button class="btn btn-primary btn-lg" (click)="toLogin()">{{'RETURN_TO_LOGIN' | translation}}</button>
            </div>
          </div>
        </div>
      </div>
    }

    @if (showSelectContract) {
      <div class="card shadow-lg">
        <div class="card-body">
          <div class="text-center">
            <h1 class="h3">{{'SELECT_CONTRACT' | translation}}</h1>
          </div>
          <table class="table table-hover">
            <tbody>
              @for (location of locations; track location; let idx = $index) {
                <tr style="cursor: pointer;" (click)="onUseContract(idx)">
                  <td>
                    {{ location.utilityName}}<br>
                    {{ location.description}}
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <div class="d-grid">
            <button class="btn btn-primary buttom-0 endt-0" (click)="toLogin()">Tilbage</button>
          </div>
        </div>
      </div>
    }
  </div>
</section>
